import { DEFAULT_DOG_TAG_COMPONENTS } from '~/helpers/consts';
import { _Item, DefaultDogTagComponentsData } from '~/interfaces';
import { DOLLS_CATEGORY } from '~/interfaces';
import { DogTagComponent, Doll } from '~/vortex';

import ResponseItemMap from './index';

export const prepareDolls = (responseDolls: Doll[]): Doll[] => {
    const rareDolls: Doll[] = [];
    const dolls = responseDolls
        .map((item: Doll & _Item) => {
            if (ResponseItemMap.isUniqueItem(DOLLS_CATEGORY, item)) {
                item.isUniqueItem = true;
            }

            return item;
        })
        .filter((item) => {
            return !ResponseItemMap.getExcludedDollsIds().includes(item.id);
        });

    return [...rareDolls, ...dolls];
};

interface DefaultDogTagSource {
    id?: DogTagComponent['id'];
    textureData?: DogTagComponent['textureData'];
    color?: DogTagComponent['color'];
}

export function getDefaultDogTagComponents(responseDolls: DefaultDogTagSource[]): DefaultDogTagComponentsData {
    return responseDolls.reduce<DefaultDogTagComponentsData>((acc, doll) => {
        switch (doll.id) {
            case DEFAULT_DOG_TAG_COMPONENTS.TEXTURE_ID:
                acc.textureData = doll.textureData;
                break;
            case DEFAULT_DOG_TAG_COMPONENTS.BACKGROUND_COLOR_ID:
                acc.backgroundColor = doll.color;
                break;
            case DEFAULT_DOG_TAG_COMPONENTS.BORDER_COLOR_ID:
                acc.borderColor = doll.color;
                break;
        }
        return acc;
    }, {});
}
